import React, { useState } from 'react';
import Sidebar from './Sidebar';
import PageTransition from '../PageTransition';
import { LayoutProps } from '../../types';

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Mobile menu button */}
      <button
        onClick={toggleMobileMenu}
        className="lg:hidden fixed top-4 left-4 z-50 p-2 rounded-md bg-white shadow-lg border border-gray-200 hover:bg-gray-50 transition-colors mobile-menu-button"
        aria-label="Toggle mobile menu"
      >
        <svg className="h-6 w-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      </button>

      {/* Mobile menu overlay */}
      {isMobileMenuOpen && (
        <div 
          className="lg:hidden fixed inset-0 bg-black bg-opacity-50 z-40"
          onClick={closeMobileMenu}
        />
      )}

      {/* Mobile Sidebar - Fixed overlay */}
      <div className={`lg:hidden ${isMobileMenuOpen ? 'block' : 'hidden'}`}>
        <Sidebar onClose={closeMobileMenu} />
      </div>

      {/* Desktop Layout with Grid */}
      <div className="hidden lg:grid lg:grid-cols-[256px_1fr] min-h-screen">
        {/* Desktop Sidebar */}
        <div className="lg:col-start-1 lg:col-end-2">
          <Sidebar onClose={closeMobileMenu} />
        </div>

        {/* Desktop Main content */}
        <main className="lg:col-start-2 lg:col-end-3 p-6 lg:p-8">
          <PageTransition>
            {children}
          </PageTransition>
        </main>
      </div>

      {/* Mobile Main content - Full width when sidebar is closed */}
      <main className={`lg:hidden p-6 ${isMobileMenuOpen ? 'hidden' : 'block'}`}>
        <PageTransition>
          {children}
        </PageTransition>
      </main>
    </div>
  );
};

export default Layout;
